import { each, some } from '@antv/util';
import { IList, ListItem } from '../../../dependents';
import ListState from './list-state';

const STATUS_UNCHECKED = 'unchecked';
const STATUS_CHECKED = 'checked';
type MatchCallback = (item: ListItem) => boolean;

/**
 * checked Action
 * æä¾ä¸ä¸ªå¯¹å¤æ¹æ³
 * 1. toggle åæ¢ç¶æ
 * 2. checked éä¸­
 * 3. reset æ¸é¤éç½®
 */
class ListChecked extends ListState {
  protected stateName: string = STATUS_CHECKED;

  // åä¸ª item è®¾ç½®ç¶æ
  protected setItemState(list: IList, item: ListItem, enable: boolean) {
    this.setCheckedBy(list, (el) => el === item, enable);
  }

  // æ ¹æ®æ¡ä»¶è®¾ç½® checked
  private setCheckedBy(list: IList, callback: MatchCallback, enable: boolean) {
    const items = list.getItems();
    if (enable) {
      // è®¾ç½® checked æ¶ï¼ä¿çä¹åå·²ç» checked çé¡¹
      each(items, (item) => {
        if (callback(item)) {
          if (list.hasState(item, STATUS_UNCHECKED)) {
            list.setItemState(item, STATUS_UNCHECKED, false);
          }
          list.setItemState(item, STATUS_CHECKED, true);
        } else if (!list.hasState(item, STATUS_CHECKED)) {
          list.setItemState(item, STATUS_UNCHECKED, true);
        }
      });
    }
  }

  /**
   * åæ¢ç¶æ.
   * 1. å½å¨é¨éä¸­çæ¶å æè å½å item æªéä¸­æ¶ï¼è¿è¡æ¿æ´»æä½
   * 2. å¦åï¼éç½®
   * @override
   */
  public toggle() {
    const triggerInfo = this.getTriggerListInfo();
    if (triggerInfo && triggerInfo.item) {
      const { list, item } = triggerInfo;

      // ä¸ç¥é ð¤·ââï¸ åªè®¤ unchecked status
      const allChecked = !some(list.getItems(), (t) => list.hasState(t, STATUS_UNCHECKED));

      //
      if (allChecked || list.hasState(item, STATUS_UNCHECKED)) {
        this.setItemState(list, item, true);
      } else {
        this.reset();
      }
    }
  }

  /**
   * checked å¾ä¾é¡¹
   */
  public checked() {
    this.setState();
  }

  /**
   * éç½®ï¼éè¦å¨é¨æ¸ç checked å unchecked
   */
  public reset() {
    const components = this.getAllowComponents();
    each(components, (component) => {
      component.clearItemsState(STATUS_CHECKED);
      component.clearItemsState(STATUS_UNCHECKED);
    });
  }
}

export default ListChecked;
